import CityPageTemplate from "../city-template/CityPageTemplate";
import { eauClaireConfig } from "./data";

export default function EauClairePage() {
  return <CityPageTemplate config={eauClaireConfig} />;
}